import { colors } from '../../design-tokens/colors.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const SplitComponentGraphic = ({
  foregroundColor,
  backgroundColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 643 455",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 455),
    ...svgProps,
    fill: "none",
    children: [/*#__PURE__*/jsx("path", {
      "data-background": true,
      fill: backgroundColor || colors.accent({
        alpha: 0.3
      }),
      d: "M456.717 108.214C574.612 166.19 622.71 219.933 591.422 290.206c-35.993 80.839-131.896 66.962-183.439 93.123-81.963 41.6-115.528 83.136-256.678 68.385-166.172-17.367-191.667-245.836-92.06-324.757 89.582-70.979 279.577-76.719 397.472-18.743Z"
    }), /*#__PURE__*/jsx("path", {
      "data-foreground": true,
      fill: foregroundColor || colors.primary({
        alpha: 0.5
      }),
      fillOpacity: ".2",
      d: "M533.419 141.004c170.268 78.136 103.64 168.299 49.384 222.615-62.413 62.484-164.336 7.831-219.65 12.897-87.96 8.056-89.345 60.152-229.149-27.927C-1.732 263.074 58.752 44.192 176.431 7.679c105.836-32.837 186.721 55.19 356.988 133.325Z",
      opacity: ".9"
    })]
  });
};

export { SplitComponentGraphic };
//# sourceMappingURL=split-component.js.map
